/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { default as ReactModal } from 'react-modal';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    onClose: PropTypes.func,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Modal = (props) => {
    const classNames = [
        'c-modal',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];

    /*
     * Handle message from Yurplan prov2
     */
    const onMessage = useCallback((e) => {
        if (e.origin !== YP_CONFIG.proV2.url) {
            return;
        }
        switch (e.data.type) {
            case 'ON_BACK_DROP_REACT_MODAL_CLICK':
                props.onClose();
                break;
            default:
                break;
        }
    }, []);

    useEffect(() => {
        window.addEventListener('message', onMessage);
        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [onMessage]);

    useEffect(() => {
        if (window.location.origin === YP_CONFIG.pro.url && window.YP.Prov2Communication) {
            window.YP.Prov2Communication().reactModalDisplayedMessage(window.parent);
            return () => window.YP.Prov2Communication().modalClosedMessage(window.parent);
        }
        return undefined;
    }, []);

    return (
        <ReactModal
            overlayClassName="c-modal__backdrop"
            isOpen
            contentLabel="Modal"
            appElement={document.querySelector('.c-dashboard-left-panel')}
            onRequestClose={props.onClose}
            ariaHideApp={false}
            shouldCloseOnOverlayClick
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </ReactModal>
    );
};

Modal.propTypes = propTypes;

Modal.defaultProps = defaultProps;

export default Modal;
